import React from 'react';

const Logos = ({ secondRow }) => {
  if (secondRow) {
    return (
      <>
        <img
          className="h-20 inline-block"
          src={`${process.env.NEXT_PUBLIC_ASSET_HOST}/static/external-logos/segment.png`}
          alt="logo-uber"
        />
        <img
          className="h-20 inline-block"
          src={`${process.env.NEXT_PUBLIC_ASSET_HOST}/static/external-logos/vroom.png`}
          alt="logo-vroom"
        />
        <img
          className="h-20 inline-block"
          src={`${process.env.NEXT_PUBLIC_ASSET_HOST}/static/external-logos/recargapay.png`}
          alt="logo-target"
        />
        <img
          className="h-20 inline-block"
          src={`${process.env.NEXT_PUBLIC_ASSET_HOST}/static/external-logos/change.png`}
          alt="logo-change"
        />
        <img
          className="h-20 inline-block"
          src={`${process.env.NEXT_PUBLIC_ASSET_HOST}/static/external-logos/optimizely.png`}
          alt="logo-optimizely"
        />
      </>
    );
  }
  return (
    <>
      <img
        className="h-20 inline-block"
        src={`${process.env.NEXT_PUBLIC_ASSET_HOST}/static/external-logos/instacart.svg`}
        alt="logo-instacart"
      />
      <img
        className="h-20 inline-block"
        src={`${process.env.NEXT_PUBLIC_ASSET_HOST}/static/external-logos/shipt.svg`}
        alt="logo-shipt"
      />
      <img
        className="h-20 inline-block"
        src={`${process.env.NEXT_PUBLIC_ASSET_HOST}/static/external-logos/redfin.svg`}
        alt="logo-redfin"
      />
      <img
        className="h-20 inline-block"
        src={`${process.env.NEXT_PUBLIC_ASSET_HOST}/static/external-logos/clearbit.svg`}
        alt="logo-clearbit"
      />
      <img
        className="h-20 inline-block"
        src={`${process.env.NEXT_PUBLIC_ASSET_HOST}/static/external-logos/doordash.svg`}
        alt="logo-doordash"
      />
    </>
  );
};

export default Logos;
